import * as unitsOfMeasure from "@signolteam/shared/units-of-measure";

export const getNumberFormatterForUnit = (unit, industry) => {
  switch (unit.toLowerCase().trim()) {
    case "%": {
      //Assume all percentages use the 0-100 scale instead of 0-1
      return (value, uncertainty, options) =>
        unitsOfMeasure.formatPercentage("0-100", value, uncertainty, options);
    }
    case "kg": {
      return (value, uncertainty, options) =>
        unitsOfMeasure.formatMass(industry, value, uncertainty, options);
    }
    case "t":
    case "tonne":
    case "tonnes":
    case "mt": {
      return (value, uncertainty, options) =>
        //convert everything back to kg
        unitsOfMeasure.formatMass(
          industry,
          value * 1000,
          typeof uncertainty === "number" ? uncertainty * 1000 : uncertainty,
          {
            ...(options || {}),
            boundaryValues:
              options?.boundaryValues?.map((bv) => bv * 1000) ?? [],
          },
        );
    }
    case "usd":
    case "$":
      return (value, currencyCodeISO, options) =>
        unitsOfMeasure.formatCurrency(currencyCodeISO || "USD", value, options);
    default: {
      return (value, uncertainty, options) =>
        unitsOfMeasure.formatNumber(value, { unit, uncertainty, options });
    }
  }
};
